<template>
  <m-categories-wrapper :slicer="slicer" :single-category="category">
    <template slot-scope="{ categories,imageHandler ,setLinkType}">
      <b-container class="col-lg-12 my-5 mx-auto categories305">

        <b-row>
          <b-col class="my-1" lg="4"  v-for="category in categories"
                 :key="category.id">
            <div>
              <m-a :href="setLinkType(category,linkType)" class="  ">
                <m-c305 class="c305" :image="imageHandler(category,findAttributeOnSiteInfo('icon')[0])"
                        :alt="category.name">
                  <template #p-1>

                    <b-row class="bg-white py-1  container mx-auto rounded rounded-5">
                      <b-col cols="10">
                        <h6 class="text-dark my-2">{{ category.name }}</h6>
                      </b-col>
                      <b-col cols="2">
                        <b-icon class="h5 my-2 text-dark" icon="chevron-left"/>
                      </b-col>
                    </b-row>

                  </template>
                </m-c305>
              </m-a>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </template>
  </m-categories-wrapper>
</template>

<script>
export default {
  name: "categories305",
  props: {
    alternativeCategoryImage: {
      default: () => {
        return ''
      }
    },
    linkType: {
      default: 'blog'
    },
    category: {
      default: null,
    },
    slicer:{
      default: Infinity,
    }
  },
}
</script>

<style scoped>
.categories305 .c305 {
  background: var(--primary);
}
</style>